module.exports = __webpack_public_path__ + "img/profileWhite.189df369.svg";